import { FontAwesome, Ionicons, MaterialIcons } from "@expo/vector-icons";
import AsyncStorage from "@react-native-async-storage/async-storage";
import {
	Box,
	Button,
	HStack,
	Icon,
	IconButton,
	StatusBar,
	Text,
	Tooltip,
	useMediaQuery,
} from "native-base";
import React from "react";
import { Image, View, Pressable } from "react-native";
import { useDispatch, useSelector } from "react-redux";
import { currencyFormat } from "../../components/dynamic/ComponentsGenerator";
import { getBalance } from "../../redux/slices/BalanceSlice";
import { getCardBalance } from "../../redux/slices/CardBalanceSlice";
import { removeAuth } from "../../redux/slices/LoginSlice";
import AppConstants from "../../utils/Constants";
import {
	getBrandHeaderBackground,
	getBrandHeaderDividerColor,
	getBrandHeaderTextColor,
	getBrandLogo,
	getStatusBarContentColor,
	isWeb,
} from "../../utils/utils";

const BRAND_URL = isWeb()
	? AppConstants.WindowHostname
	: AppConstants.CIP_BRAND;

const MemberHeader = ({ props }) => {
	const isDesktopOrLaptop = useMediaQuery({ minWidth: 960 });
	const dispatch = useDispatch();

	React.useEffect(() => {
		dispatch(getBalance());
		dispatch(getCardBalance());
	}, []);

	const Auth = useSelector((state) => state.Login.Auth);
	const balance = useSelector((state) => state.balance.Balance);
	const CardBalance = useSelector((state) => state.cardBalance.Balance);

	const isXiaomi = BRAND_URL === AppConstants.XiaomiURL;

	React.useEffect(() => {
		if (props.route.name === "Logout") {
			dispatch(removeAuth());
			AsyncStorage.removeItem("auth");
			props.navigation.navigate("Main Menu");
		}
	}, [props.route]);

	return (
		<>
			<StatusBar barStyle={getStatusBarContentColor()} />
			<Box safeAreaTop bg={getBrandHeaderBackground()} />
			<View>
				<HStack
					bg={getBrandHeaderBackground()}
					px="2"
					justifyContent="space-between"
					alignItems="center"
				>
					<HStack space="4" alignItems="center" justifyContent="space-between">
						{isDesktopOrLaptop[0] === false && (
							<IconButton
								onPress={() => props.navigation.toggleDrawer()}
								icon={
									<Icon
										color={getBrandHeaderTextColor()}
										size="sm"
										as={<MaterialIcons name="menu" />}
									/>
								}
							/>
						)}
						{isDesktopOrLaptop[0] === true ? (
							<Pressable onPress={() => props.navigation.navigate("Main Menu")}>
								<Image
									resizeMode="contain"
									source={{
										uri: isWeb()
											? getBrandLogo()
											: Image.resolveAssetSource(getBrandLogo()).uri,
									}}
									style={{
										width: 200,
										height: 50,
										marginVertical: 5,
										marginLeft: isWeb() ? 50 : "auto",
									}}
								/>
							</Pressable>
						) : (
							<Text
								color={getBrandHeaderTextColor()}
								fontSize="20"
								fontWeight="900"
							>
								{props.route.name}
							</Text>
						)}
					</HStack>
					{!isDesktopOrLaptop[0] && props.route.name !== "Profile" && (
						<HStack space="2" alignItems="center" textTransform="capitalize">
							<IconButton
								margin={0.5}
								onPress={() => props.navigation.navigate("Profile")}
								icon={
									<Icon
										as={MaterialIcons}
										name="person-outline"
										size="md"
										color={getBrandHeaderTextColor()}
									/>
								}
							/>
						</HStack>
					)}
					{isDesktopOrLaptop[0] && (
						<HStack space="2" alignItems="center" textTransform="capitalize">
							<View
								style={{
									width: 0.5,
									backgroundColor: getBrandHeaderDividerColor(),
									height: 60,
								}}
							/>
							<Tooltip label="Card Balance" openDelay={500}>
								<Button
									// onPress={() => props.navigation.navigate(item.page_title)}
									variant="ghost"
									leftIcon={
										<Icon as={FontAwesome} name="credit-card" size="xs" />
									}
								>
									<Text
										color={getBrandHeaderTextColor()}
										fontSize="12"
										fontWeight="semibold"
									>
										{currencyFormat(Number(CardBalance) / 100)}
									</Text>
								</Button>
							</Tooltip>
							<View
								style={{
									width: 0.5,
									backgroundColor: getBrandHeaderDividerColor(),
									height: 60,
								}}
							/>
							<Tooltip label="Wallet Balance" openDelay={500}>
								<Button
									// onPress={() => props.navigation.navigate(item.page_title)}
									variant="ghost"
									leftIcon={<Icon as={Ionicons} name="wallet" size="xs" />}
								>
									<Text
										color={getBrandHeaderTextColor()}
										fontSize="12"
										fontWeight="semibold"
									>
										{currencyFormat(Number(balance) / 100)}
									</Text>
								</Button>
							</Tooltip>
							<View
								style={{
									width: 0.5,
									backgroundColor: getBrandHeaderDividerColor(),
									height: 60,
								}}
							/>
							<Tooltip label="Click to access Profile" openDelay={500}>
								<Button
									onPress={() => props.navigation.navigate("Profile")}
									variant="ghost"
									leftIcon={<Icon as={Ionicons} name="person" size="xs" />}
								>
									<Text
										color={getBrandHeaderTextColor()}
										fontSize="13"
										fontWeight="semibold"
									>
										{`${
											Auth.profile.data.filter(
												(profile) => profile.type_name === "first_name"
											)[0]?.data_text
										} ${
											Auth.profile.data.filter(
												(profile) => profile.type_name === "second_name"
											)[0]?.data_text
										}`}
									</Text>
								</Button>
							</Tooltip>
							<Tooltip label="Role" openDelay={500}>
								<Button
									onPress={() => props.navigation.navigate("Profile")}
									variant="ghost"
									leftIcon={
										<Icon
											as={FontAwesome}
											name="building"
											size="xs"
											style={{ margin: 0, padding: 0 }}
										/>
									}
								>
									<Text
										color={getBrandHeaderTextColor()}
										fontSize="13"
										fontWeight="semibold"
									>
										{Auth.profile.role}
									</Text>
								</Button>
							</Tooltip>
						</HStack>
					)}
				</HStack>
				{isXiaomi && (
					<View
						style={{ backgroundColor: "#F26A21", height: 6, width: "100%" }}
					/>
				)}
			</View>
		</>
	);
};

export default MemberHeader;
